import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import * as Styled from './LoginContainer.styles';

const LoginContainer = () => {
  const { t } = useTranslation();

  return (
    <Styled.PageLayout>
      <Styled.SiderContainer width="858px">
        <Styled.SiderContent>
          <Styled.WelcomeText>{t('loginPage.welcomeTo')}</Styled.WelcomeText>
          <Styled.DescriptionText>{t('loginPage.passportingTool')}</Styled.DescriptionText>
          <Styled.EntryContainer>
            <Outlet />
          </Styled.EntryContainer>
          <Styled.PoweredBy />
        </Styled.SiderContent>
      </Styled.SiderContainer>
      <Styled.Background>
        <Styled.Logo />
        <Styled.Watermark />
      </Styled.Background>
    </Styled.PageLayout>
  );
};

export default LoginContainer;
